import Scoutfy1 from "../assets/projects/project-scoutfy1.png";
import Scoutfy2 from "../assets/projects/project-scoutfy2.png";
import BNB1 from "../assets/projects/project-bnb1.png";
import BNB2 from "../assets/projects/project-bnb2.png";
import BNB3 from "../assets/projects/project-bnb3.png";
import BNBRN1 from "../assets/projects/project-bnb-rn0.png";
import BNBRN2 from "../assets/projects/project-bnb-rn1.png";
import BNBRN3 from "../assets/projects/project-bnb-rn2.png";
import Caule1 from "../assets/projects/project-caule1.png";
import Caule2 from "../assets/projects/project-caule2.png";
import CoffeeHouse1 from "../assets/projects/project-coffeehouse1.png";
import CoffeeHouse2 from "../assets/projects/project-coffeehouse2.png";
import CoffeeHouse3 from "../assets/projects/project-coffeehouse3.png";
import WeeTravel1 from "../assets/projects/project-weetravel1.png";
import WeeTravel2 from "../assets/projects/project-weetravel2.png";
import FilmNChips1 from "../assets/projects/project-film-n-chips1.png";
import FilmNChips2 from "../assets/projects/project-film-n-chips2.png";
import FilmNChips3 from "../assets/projects/project-film-n-chips3.png";
import APPqd1 from "../assets/projects/project-appqd1.png";
import APPqd2 from "../assets/projects/project-appqd2.png";
import WA1 from "../assets/projects/project-wa1.png";
import WA2 from "../assets/projects/project-wa2.png";
import WA3 from "../assets/projects/project-wa3.png";
import GoFinances1 from "../assets/projects/project-gofinances2.png";
import GoFinances2 from "../assets/projects/project-gofinances3.png";
import Portfolio1 from "../assets/projects/project-portfolio1.png";
import Portfolio2 from "../assets/projects/project-portfolio2.png";
import Portfolio3 from "../assets/projects/project-portfolio3.png";
import DevMeetup1 from "../assets/projects/project-devmeetup1.png";
import DevMeetup2 from "../assets/projects/project-devmeetup2.png";
import DevMeetup3 from "../assets/projects/project-devmeetup3.png";
import BritishBeers1 from "../assets/projects/project-british-beers1.png";
import BritishBeers2 from "../assets/projects/project-british-beers2.png";
import BritishBeers3 from "../assets/projects/project-british-beers3.png";
import CNH1 from "../assets/projects/project-cnh1.png";
import CNH2 from "../assets/projects/project-cnh2.png";
import DigitalPlatform1 from "../assets/projects/project-bnb-digital-platform1.png";
import DigitalPlatform2 from "../assets/projects/project-bnb-digital-platform2.png";
import DigitalPlatform3 from "../assets/projects/project-bnb-digital-platform3.png";
import CVFY from "../assets/projects/project-cvfy0.png";
import BNBUI1 from "../assets/projects/project-bnb-ui1.png";
import BNBUI2 from "../assets/projects/project-bnb-ui2.png";
import BNBUI3 from "../assets/projects/project-bnb-ui3.png";
import BDOD1 from "../assets/projects/project-bdod1.png";
import BDOD2 from "../assets/projects/project-bdod2.png";
import BDOD3 from "../assets/projects/project-bdod3.png";
import JENKINSLOGAI1 from "../assets/projects/project-jenkinslogai1.png";
import JENKINSLOGAI2 from "../assets/projects/project-jenkinslogai2.png";
import JENKINSLOGAI3 from "../assets/projects/project-jenkinslogai3.png";
import JARVIS1 from "../assets/projects/project-jarvis1.png";
import JARVIS2 from "../assets/projects/project-jarvis2.png";
import JARVIS3 from "../assets/projects/project-jarvis3.png";
import CC1 from "../assets/projects/project-cc1.png";
import CC2 from "../assets/projects/project-cc2.png";
import CC3 from "../assets/projects/project-cc3.png";
import CoreLearn1 from "../assets/projects/project-corelearn1.png";
import CoreLearn2 from "../assets/projects/project-corelearn2.png";
import CoreLearn3 from "../assets/projects/project-corelearn3.png";

export interface ProjectText {
  id: string;
  text: string;
}

export interface ProjectImage {
  id: string;
  src: string;
  alt: string;
}

export interface ProjectDetailsSchema {
  id: string;
  name: string;
  date: string;
  type: string;
  professional: boolean;
  skills: string[];
  about: ProjectText[];
  website?: string;
  github?: string;
  appleStore?: string;
  playStore?: string;
  images: ProjectImage[];
}

export const enIntroProjectDetailsData = {
  skills: "Skills & Tools",
  overview: "Project Overview",
  website: "Visit website",
  apple: "Download from Apple Store",
  play: "Download from Play Store",
  code: "Check out the code",
};

export const ptIntroProjectDetailsData = {
  skills: "Habilidades",
  overview: "Sobre o Projeto",
  website: "Visite o site",
  apple: "Baixe na Apple Store",
  play: "Baixe na Play Store",
  code: "Confira o código",
};

export const enProjectDetailsData = [
  {
    id: "corelearn",
    name: "CoreLearn",
    date: "Jul 2025 - Jan 2026",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "TypeScript",
      "Contentful",
      "Headless CMS",
      "Next.js App Router",
      "Dynamic Routes",
      "Rich Text Rendering",
      "next/image",
      "Jest",
      "GitHub Actions",
      "Vercel",
    ],
    about: [
      {
        id: "corelearn1",
        text: "I had the opportunity to work on an internal training website for our team, where we used headless CMS integration, content modeling with Contentful, dynamic routes with Next.js App Router, CMS data normalization with mapper functions, environment variable management, Rich Text rendering from Contentful, remote image rendering with next/image, video embed rendering, content revalidation strategy, unit tests with Jest, CI with GitHub Actions, and deployment with Vercel.",
      },
      {
        id: "corelearn2",
        text: "Because the original project is internal and cannot be publicly shared, I created CoreLearn as a personal project using the same technologies and practices. The goal was to demonstrate my practical knowledge in building a CMS-driven learning platform with structured content, dynamic lesson pages, reusable front-end components, and production-oriented configuration.",
      },
      {
        id: "corelearn3",
        text: "CoreLearn allowed me to practice the full workflow of a modern headless frontend: modeling content in Contentful, consuming and normalizing CMS data, rendering rich content and embedded videos, handling remote images safely, validating environment variables, adding unit tests, configuring CI, defining a revalidation strategy, and deploying the application on Vercel.",
      },
    ],
    website: "https://corelearn.vercel.app/",
    github: "https://github.com/thiagocabralcorreia/corelearn",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "corelearn1.png",
        src: CoreLearn1,
        alt: "CoreLearn course listing page",
      },
      {
        id: "corelearn2.png",
        src: CoreLearn2,
        alt: "CoreLearn lesson details page",
      },
      {
        id: "corelearn3.png",
        src: CoreLearn3,
        alt: "CoreLearn responsive page layout",
      },
    ],
  },
  {
    id: "cc",
    name: "Cabral Correia Author Website",
    date: "Jun 2026",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "Responsive Web Design",
      "React Hook Form",
      "Zod",
      "Jest",
      "React Testing Library",
      "Accessibility",
      "SEO",
    ],
    about: [
      {
        id: "cc1",
        text: "Cabral Correia Author Website is a personal project created after publishing my first book, Carne e Osso. Besides writing code professionally, I also write short stories, and this website was designed to present my literary work, selected stories, book information, contact options, and social links in a consistent author-brand experience.",
      },
      {
        id: "cc2",
        text: "From a technical perspective, I built this project as a practical demonstration of my experience with modern front-end architecture. It uses Next.js App Router, TypeScript, Tailwind CSS, reusable components, dynamic routes for individual stories, custom metadata for SEO, optimized images, and a responsive layout focused on readability and visual consistency.",
      },
      {
        id: "cc3",
        text: "The project also includes form validation with React Hook Form and Zod, unit and component tests with Jest and React Testing Library, accessibility improvements such as semantic HTML, keyboard navigation, skip link, aria attributes, focus-visible styles, and a custom 404 page. It is a real production-oriented website, not just a study project.",
      },
    ],
    website: "https://www.cabralcorreia.com.br",
    github: "https://github.com/thiagocabralcorreia/cabral-correia",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "cc1.png",
        src: CC1,
        alt: "Cabral Correia Author Website hero section",
      },
      {
        id: "cc2.png",
        src: CC2,
        alt: "Cabral Correia Author Website stories section",
      },
      {
        id: "cc3.png",
        src: CC3,
        alt: "Cabral Correia Author Website book page",
      },
    ],
  },
  {
    id: "bnb",
    name: "Cordel Design System React Library",
    date: "May 2023 - Present",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "SCSS",
      "Responsive Web Design",
      "Storybook",
      "Jest",
      "React Testing",
      "Vite",
    ],
    about: [
      {
        id: "bnb1",
        text: "Through Stefanini, I was hired to work at Banco do Nordeste (BNB), the largest social development bank in Latin America. Alongside the UX team, I am part of building the bank's Design System, Cordel, with the mission of bridging the gap between designers and developers.",
      },
      {
        id: "bnb2",
        text: "My most impactful task has been creating the Cordel library (a library of user interface components). This work involves translating design and variables into code, producing a complex set of over 50 components that are reused across multiple company websites, ensuring high productivity in developing future screens.",
      },
      {
        id: "bnb3",
        text: "For the web-focused library, I used React.js with Vite, TypeScript, SCSS, and Storybook (to showcase, document, and test each component in isolation). Through an API developed by us, Figma's variables and tokens are converted from JSON to SCSS files, updating themes, measurements, and other styles in real-time. Additionally, I performed automated tests on each component using Jest and React Testing Library.",
      },
      {
        id: "bnb4",
        text: "• Note: At the moment, the library is accessed only by the bank's IT employees.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnb1.png",
        src: BNB1,
        alt: "Cordel Design System component shown in Storybook",
      },
      {
        id: "bnb2.png",
        src: BNB2,
        alt: "Cordel Design System component shown in Storybook",
      },
      {
        id: "bnb3.png",
        src: BNB3,
        alt: "Cordel Design System component shown in Storybook",
      },
    ],
  },
  {
    id: "bnbrn",
    name: "Cordel Design System React Native Library",
    date: "Mar 2025 - Present",
    type: "Web",
    professional: true,
    skills: [
      "React Native",
      "TypeScript",
      "Storybook",
      "Jest",
      "React Native Testing",
      "React Compound Pattern",
    ],
    about: [
      {
        id: "bnbrn1",
        text: "Just like I was responsible for the React library of the Cordel Design System, I also helped build the React Native version, focused on mobile applications. This time, with everything I learned before, the process went much smoother — and the result turned out to be lightweight, consistent, and really practical to use.",
      },
      {
        id: "bnbrn2",
        text: "It’s great to see developers building apps with this library — it feels like playing with Lego. The components are already polished and ready to use, so they can just focus on the logic. We used React Native, TypeScript, and Storybook to document and test everything properly, along with an API that converts Figma tokens into JavaScript objects, updating themes and styles in real time.",
      },
      {
        id: "bnbrn3",
        text: "• Note: For now, the library is only used in the bank’s internal projects, so the code and applications are not publicly available.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbrn1.png",
        src: BNBRN1,
        alt: "Cordel Design System React Native Library component displayed in Storybook",
      },
      {
        id: "bnbrn2.png",
        src: BNBRN2,
        alt: "Cordel Design System React Native Library component displayed in Storybook",
      },
      {
        id: "bnbrn3.png",
        src: BNBRN3,
        alt: "Cordel Design System React Native Library component displayed in Storybook",
      },
    ],
  },
  {
    id: "bnbui",
    name: "BNB-UI",
    date: "May 2023 - Aug 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Material-UI",
      "Responsive Web Design",
      "Storybook",
    ],
    about: [
      {
        id: "bnbui1",
        text: "Before starting the React library for the Banco do Nordeste’s Design System (Cordel), I contributed to the development and maintenance of an existing React component library, the BNB-UI. Unlike the new library, where all components were created from scratch and styled with SCSS, the BNB-UI was built using Material-UI, following the best practices defined by Google through Material Design.",
      },
      {
        id: "bnbui2",
        text: "In addition to maintenance and creating custom components as requested by the client, I also updated all documentation in Storybook. However, when developing the Design System, I built a more authentic and comprehensive React library that follows the visual standard and consistency that will be maintained across other libraries in different languages. It’s worth mentioning that I added improvements such as the use of Jest for unit testing, ensuring greater robustness and reliability of the components.",
      },
      {
        id: "bnbui3",
        text: "• Note: At the moment, the library is accessed only by the bank's IT employees.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbui1.png",
        src: BNBUI1,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
      {
        id: "bnbui2.png",
        src: BNBUI2,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
      {
        id: "bnbui3.png",
        src: BNBUI3,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
    ],
  },
  {
    id: "bnbui",
    name: "BNB-UI",
    date: "Mai 2023 - Ago 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Material-UI",
      "Responsive Web Design",
      "Storybook",
    ],
    about: [
      {
        id: "bnbui1",
        text: "Antes de iniciar a biblioteca React para o Design System do Banco do Nordeste, contribuí para o desenvolvimento de funcionalidades e manutenção de uma biblioteca de componentes React já existente, a BNB-UI. Ao contrário da nova biblioteca, onde todos os componentes foram criados do zero e estilizados com SCSS, a BNB-UI foi construída com Material-UI, seguindo as boas práticas definidas pelo Google através do Material Design.",
      },
      {
        id: "bnbui2",
        text: "Além da manutenção e criação de novos componentes personalizados, conforme solicitado pelo cliente, também atualizei toda a documentação no Storybook. Contudo, ao desenvolver o Design System, construí uma biblioteca React mais autêntica e completa, que segue o padrão visual e a consistência que serão mantidos em outras bibliotecas de diferentes linguagens. Vale ressaltar que adicionei melhorias, como o uso do Jest para testes unitários, garantindo maior robustez e confiabilidade dos componentes.",
      },
      {
        id: "bnbui3",
        text: "• Nota: No momento, a biblioteca está acessível apenas para funcionários.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbui1.png",
        src: BNBUI1,
        alt: "BNB-UI introdução apresentada no Storybook",
      },
      {
        id: "bnbui2.png",
        src: BNBUI2,
        alt: "BNB-UI apresentado no Storybook",
      },
      {
        id: "bnbui3.png",
        src: BNBUI3,
        alt: "BNB-UI apresentado no Storybook",
      },
    ],
  },
  {
    id: "digital-platform",
    name: "BNB Digital Platform",
    date: "May 2023 - Aug 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Docusaurus",
      "Markdown",
      "Responsive Web Design",
      "Gitlab",
    ],
    about: [
      {
        id: "bnbdp1",
        text: "Although my main task was to build the React component library for Banco do Nordeste's (BNB) Design System, my first project was the Digital Platform, a collaborative documentation website created with Docusaurus, a static site generator that allows the combination of Markdown with React components.",
      },
      {
        id: "bnbdp2",
        text: "This portal is used by all Banco do Nordeste's IT employees to inform and be informed about guidelines and guides for performing development and testing activities. This implementation resulted in an increase of more than 50% in engagement compared to the previous version of the Digital Platform.",
      },
      {
        id: "bnbdp3",
        text: "• Note: The portal is accessed only by the bank's IT employees, and its site cannot be disclosed.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbpd1.png",
        src: DigitalPlatform1,
        alt: "Digital Platform portal",
      },
      {
        id: "bnbpd2.png",
        src: DigitalPlatform2,
        alt: "Digital Platform portal",
      },
      {
        id: "bnbpd3.png",
        src: DigitalPlatform3,
        alt: "Digital Platform portal",
      },
    ],
  },
  {
    id: "scoutfy",
    name: "Scoutfy",
    date: "Jul 2021 - Apr 2022",
    type: "Web",
    professional: true,
    skills: [
      "Next.js",
      "Responsive Web Design",
      "Styled-Components",
      "Storybook",
      "Redux Toolkit",
      "CI/CD",
      "Vercel",
    ],
    about: [
      {
        id: "scoutfy1",
        text: "This was the first professional project I developed with React and Next.js, a large-scale website, an important learning experience, complex, responsive, and full of reusable components.",
      },
      {
        id: "scoutfy2",
        text: "Scoutfy is an intuitive sports management platform for amateurs to high-performance athletes, who can build a sports summary, apply for grants and sponsorships, contact the community, manage affiliations, members, events, competitions, teams, commission members, subscriptions and staff.",
      },
    ],
    website: "https://scoutfy.webflow.io",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "scoutfy1.png",
        src: Scoutfy1,
        alt: "Scoutfy logo",
      },
      {
        id: "scoutfy2.png",
        src: Scoutfy2,
        alt: "Scoutfy website login page",
      },
    ],
  },
  {
    id: "caule",
    name: "Caule",
    date: "Aug 2022 - Feb 2023",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "TypeScript",
      "REST API",
      "Styled-Components",
      "GitLab",
    ],
    about: [
      {
        id: "caule1",
        text: "One of the most ambitious projects I've been a part of. When joining the Nano Incub team, my first challenge was to work on the mobile development of this complete business platform, Caule, used by more than 30,000 employees from the biggest mills in the country.",
      },
      {
        id: "caule2",
        text: "Caule is a Mobile tailored for large corporations that have thousands of employees geographically distributed (in the office, in the countryside, remotely), making life easier for both employer and employee.",
      },
      {
        id: "caule3",
        text: "Through the app, employees can access payroll and annual leave, receive handouts, distribute institutional content and several other custom functionalities - all integrated with the main Enterprise Resource Planning’s on the market (SAP, Totvs, and Senior). It's implementation brings high performance against the slowness of bureaucratic processes.",
      },
    ],
    website: "https://caule.app",
    github: "",
    appleStore: "https://apps.apple.com/br/app/caule/id6444843213",
    playStore: "https://play.google.com/store/apps/details?id=com.caule.app",
    images: [
      {
        id: "caule1.png",
        src: Caule1,
        alt: "Smartphones with Caule App screens",
      },
      {
        id: "caule2.png",
        src: Caule2,
        alt: "Smartphones with Caule App screens",
      },
    ],
  },
  {
    id: "coffee-house",
    name: "CoffeeHouse",
    date: "Sep 2021 - Nov 2021",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "Context API",
      "JavaScript",
      "HTML",
      "SASS",
      "Photoshop",
      "Illustrator",
    ],
    about: [
      {
        id: "ch1",
        text: "This was my first personal project, built from scratch with my ideas and design. As a coffee lover, I was super excited to create a fictional London coffee shop chain: brand, visual identity, menu and addresses. I even elaborated the graphic arts with signs, facades and banners of this site, edited with Adobe Photoshop.",
      },
      {
        id: "ch2",
        text: "It was a challenging and really fun way to put my knowledge of React.js into practice. Among the features: responsive design using Sass, an infinite Image slider, mobile menu, gallery grid with slideshow modal, an adresses page using store filter, coffee quiz with score, contact form and newsletter subscribe with validation, menu page with context, CSS animations and charts.",
      },
    ],
    website: "https://coffeehouse-website-kohl.vercel.app",
    github: "https://github.com/thiagocabralcorreia/coffeehouse-website",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "coffeehouse1.png",
        src: CoffeeHouse1,
        alt: "CoffeeHouse website page",
      },
      {
        id: "coffeehouse2.png",
        src: CoffeeHouse2,
        alt: "CoffeeHouse website page",
      },

      {
        id: "coffeehouse3.png",
        src: CoffeeHouse3,
        alt: "CoffeeHouse website page",
      },
    ],
  },
  {
    id: "wee-travel",
    name: "Wee Travel",
    date: "Apr 2021 - Aug 2021",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "Styled-Components",
      "JavaScrip",
      "Redux",
      "GitHub",
    ],
    about: [
      {
        id: "wee1",
        text: "Developed as soon as I joined NB Consulting. A corporate travel management mobile app with up-to-date information about airlines, OBT (Online booking travel) and Enterprise Resource Planning, accessed by different profiles, such as travel manager, cost center manager and traveler.",
      },
    ],
    website: "https://weetravel.com.br/",
    github: "",
    appleStore: "",
    playStore:
      "https://play.google.com/store/apps/details?id=br.com.tursites.weereceptivocombr&hl=pt_PT",
    images: [
      {
        id: "weetravel1.png",
        src: WeeTravel1,
        alt: "Smartphones with WeeTravel App screens",
      },
      {
        id: "weetravel2.png",
        src: WeeTravel2,
        alt: "Smartphones with WeeTravel App screens",
      },
    ],
  },
  {
    id: "film-n-chips",
    name: "Film N Chips",
    date: "Jul 2022",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "REST API",
      "Redux Toolkit",
      "Styled-Components",
      "Vercel Deploy",
    ],
    about: [
      {
        id: "film1",
        text: "After finishing a Udemy course, React Redux, I decided to put what I learned into practice. Fascinated by movies, I created my own movie website, with data from the IMDb API.",
      },
      {
        id: "film2",
        text: "This is a movie database site. Online movie-related data like movie specs, plot, cast, posters, ratings, and more. Website deployed on Vercel. This API only allows 1,000 requests per day.",
      },
    ],
    website: "https://film-and-chips-website.vercel.app",
    github: "https://github.com/thiagocabralcorreia/film-and-chips-website",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "film-n-chips1.png",
        src: FilmNChips1,
        alt: "Film N Chips website page",
      },
      {
        id: "film-n-chips2.png",
        src: FilmNChips2,
        alt: "Film N Chips website page",
      },

      {
        id: "film-n-chips3.png",
        src: FilmNChips3,
        alt: "Film N Chips website page",
      },
    ],
  },
  {
    id: "appqd",
    name: "APPqd",
    date: "Apr 2021 - Aug 2021",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "Styled-Components",
      "JavaScrip",
      "Redux",
      "GitHub",
    ],
    about: [
      {
        id: "appqd1",
        text: "My second professional mobile app project, at NB Consulting IT. This is a very unique app, a logbook that helps skydivers. Among the various features, there are simulators, wing loading calculator, wind and weather forecast, data notebook and jump equipment.",
      },
      {
        id: "appqd2",
        text: "The user interface is very simple and beautiful, and I remember hearing a lot of praise from satisfied customers.",
      },
    ],
    website: "",
    github: "",
    appleStore:
      "https://apps.apple.com/hr/app/appqd-skydive-e-base-jump/id1548125179?l=hr",
    playStore: "https://play.google.com/store/apps/details?id=com.appqd",
    images: [
      {
        id: "appqd1.png",
        src: APPqd1,
        alt: "Smartphones with APPqd screens",
      },
      {
        id: "appqd2.png",
        src: APPqd2,
        alt: "Smartphones with APPqd screens",
      },
    ],
  },
  {
    id: "web-accessibility",
    name: "Web Accessibility",
    date: "Jul 2022",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "Responsive Web Design",
      "TypeScript",
      "Tailwind CSS",
      "Apiary",
      "AAA",
      "UX/UI",
      "Vercel",
    ],
    about: [
      {
        id: "wa1",
        text: "This responsive website was planned and developed in order to achieve theoretical knowledge and practical study on web accessibility, following good practices, such as use of contrast, alternative theme, understandable interface and easy navigation, with keyboard interaction.",
      },
      {
        id: "wa2",
        text: "Among the applied technologies, I used Next.js 13 and the new experimental features, including the new way to fetch data and handle promises inside components. Simple, well-readable user interface with a focus on user experience. I used Apiary as the API design stack to simulate data fetching. ",
      },
    ],
    website: "https://web-accessibility-nine.vercel.app",
    github: "https://github.com/thiagocabralcorreia/web-accessibility",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "wa1.png",
        src: WA1,
        alt: "Web Accessibility website page",
      },
      {
        id: "wa2.png",
        src: WA2,
        alt: "Web Accessibility website page",
      },

      {
        id: "wa3.png",
        src: WA3,
        alt: "Web Accessibility website page",
      },
    ],
  },
  {
    id: "gofinances",
    name: "GoFinances",
    date: "Sep 2022 - Oct 2022",
    type: "Mobile",
    professional: false,
    skills: [
      "React Native",
      "TypeScript",
      "Expo",
      "Styled-Components",
      "Social Login",
      "UX/UI",
    ],
    about: [
      {
        id: "finance1",
        text: "Another study mission. Through Rocketseat Ignite course, I developed an mobile app for user's personal finances management, including inflows/outflows cards, monthly summary chart and social login authentication.",
      },
      {
        id: "finance2",
        text: "I reviewed and practiced TypeScript and Styled-Components, learned about authentication with Google and Apple accounts, store with AsyncStorage, use of chart with date filters and Yup validation.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/gofinances-app",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "gofinances1.png",
        src: GoFinances1,
        alt: "Smartphones with GoFinances app screens",
      },
      {
        id: "gofinances2.png",
        src: GoFinances2,
        alt: "Smartphones with GoFinances app screens",
      },
    ],
  },
  {
    id: "portfolio",
    name: "Portfolio",
    date: "Feb 2023",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "Taildwind CSS",
      "UX/UI",
      "EmailJS",
      "Vercel Deploy",
    ],
    about: [
      {
        id: "portfolio1",
        text: "I'm proud of the work I put into this project and I hope it serves as a great representation of my skills and experience.",
      },
      {
        id: "portfolio2",
        text: "Built with React.js, TypeScript and Tailwind CSS, this website is fully responsive and includes downloadable resume, links to social media profiles, introduction section, skills list, project grid, detailed project pages, recommendation slider, and contact form powered by EmailJS.",
      },
      {
        id: "portfolio3",
        text: "To enhance the user experience, I incorporated Framer Motion for smooth animations and React Scroll for seamless scrolling between sections. More recently, I added theme switching and language selection (English and Portuguese).",
      },
    ],
    website: "https://thiagocabralcorreia.vercel.app",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "portfolio1.png",
        src: Portfolio1,
        alt: "Portfolio website home page",
      },
      {
        id: "portfolio2.png",
        src: Portfolio2,
        alt: "Portfolio website project grid",
      },
      {
        id: "portfolio3.png",
        src: Portfolio3,
        alt: "Portfolio website contact and recommendations",
      },
    ],
  },
  {
    id: "dev-meetup",
    name: "DevMeetup",
    date: "Apr 2023",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "Taildwind CSS",
      "UX/UI",
      "Node.js",
      "Express",
      "MongoDB",
      "Web Sockets",
      "JSON Web Token",
    ],
    about: [
      {
        id: "devmeetup1",
        text: "Inspired by watching and studying a MERN Bootcamp, I developed this project from Back-end to Front-end. This is a website for consulting, creating, editing and registering in developer meetups.",
      },
      {
        id: "devmeetup2",
        text: "On the front-end, I developed a responsive design with login and registration forms, a dashboard displaying all meetup events (with information and image), a category filter and much more. I also created a simple brand with icon and special font, to give more authenticity.",
      },
      {
        id: "devmeetup3",
        text: "On the back-end, I integrated user register and authentication, session control, CRUD operations, and event search using filters. It also includes event registration, uploading images to the server, site notification using web sockets, and saving images to the S3 Bucket. It was an excellent experience to work with JSON Web Token and Web Sockets.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/dev-meetup",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "devmeetup1.png",
        src: DevMeetup1,
        alt: "DevMeetup website dashboard",
      },
      {
        id: "devmeetup2.png",
        src: DevMeetup2,
        alt: "DevMeetup responsive design on smartphone screen",
      },
      {
        id: "devmeetup3.png",
        src: DevMeetup3,
        alt: "DevMeetup create event form page",
      },
    ],
  },
  {
    id: "cnh",
    name: "Comida na Hora",
    date: "Dec 2022 - Jan 2023",
    type: "Mobile",
    professional: false,
    skills: [
      "React Native",
      "TypeScript",
      "REST API",
      "Styled-Components",
      "UX/UI",
    ],
    about: [
      {
        id: "cnh1",
        text: "Launched in 2017 by entrepreneur Débora Dotto, Comida na Hora is a food delivery marketplace operating in the interior of Goiás, Brazil, with its headquarters in Mineiros/GO. The company has achieved impressive milestones, including over 16k customers, more than 400 partnered establishments, over 140k orders delivered, and revenue exceeding R$ 6 million.",
      },
      {
        id: "cnh2",
        text: "At Nano Incub, one of our missions was to develop a new version of the mobile app, which already existed and was working (its first version created with Iconic and Laravel). We rebuilt it with React Native and added new elements to improve the user experience.",
      },
    ],
    website: "https://comidanahora.com.br/",
    github: "",
    appleStore: "https://apps.apple.com/br/app/comida-na-hora/id1517670680",
    playStore:
      "https://play.google.com/store/apps/details?id=com.nanoincub.comidanahora&hl=pt&gl=US",
    images: [
      {
        id: "cnh1.png",
        src: CNH1,
        alt: "Smartphones with Comida na Hora app screens",
      },
      {
        id: "cnh2.png",
        src: CNH2,
        alt: "Smartphones with Comida na Hora app screens",
      },
    ],
  },
  {
    id: "british-beers",
    name: "British Beers",
    date: "Jun 2024",
    type: "Web",
    professional: false,
    skills: ["Next.js", "TypeScript", "Taildwind CSS", "SSR"],
    about: [
      {
        id: "britishbeers1",
        text: "This website was developed for study purposes, aiming to learn new features of Next.js App Router through practice. As a keen enthusiast of British beers, I built a simple e-commerce site focused on data retrieval.",
      },
      {
        id: "britishbeers2",
        text: "• Note: Since this project was solely for studying App Router, I created a basic API using Next.js itself. I did not focus on site responsiveness, nor did I include a shopping cart page or purchasing tool.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/british-beers",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "british-beers1.png",
        src: BritishBeers1,
        alt: "British Beers Website home page",
      },
      {
        id: "british-beers2.png",
        src: BritishBeers2,
        alt: "British Beers Website products page",
      },
      {
        id: "british-beers3.png",
        src: BritishBeers3,
        alt: "British Beers Website product details page",
      },
    ],
  },
  {
    id: "cvfy",
    name: "CVFY",
    date: "Apr 2022 - Aug 2022",
    type: "Mobile",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Styled-Components",
      "React Native",
      "MobX",
    ],
    about: [
      {
        id: "cvfy1",
        text: "I undertook a remote freelance project in collaboration with a team based in Northampton, England. This project encompassed two main areas: the development of a job search mobile application and the creation of a landing page.",
      },
      {
        id: "cvfy2",
        text: "The application was designed with a strong focus on user experience and a clean, intuitive interface. I used React Native and TypeScript to deliver a streamlined and efficient navigation experience, with job search and application features powered by artificial intelligence.",
      },
      {
        id: "cvfy3",
        text: "To complement the app, I developed a responsive, mobile-first landing page using React and TypeScript. The page was designed to maximise visitor-to-user conversion, featuring an attractive and easy-to-navigate layout. The design was implemented with Styled-components and mockups created in Adobe XD.",
      },
    ],
    website: "",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "cvfy.png",
        src: CVFY,
        alt: "CVFY logo",
      },
    ],
  },
  {
    id: "bdod",
    name: "Buscador Dizer o Direito",
    date: "Aug 2022 - Feb 2023",
    type: "Web",
    professional: true,
    skills: ["React.js", "TypeScript", "Styled-Components", "Figma"],
    about: [
      {
        id: "bdod1",
        text: "One of the most meaningful projects I’ve worked on was the front-end development of Buscador Dizer o Direito, a legal research platform that has become a key tool for thousands of law students and professionals in Brazil. Created by Professor Márcio Cavalcante, the platform evolved from a personal blog into a comprehensive digital product offering curated legal content from Brazil’s top courts.",
      },
      {
        id: "bdod2",
        text: "My role was to help transform this vast and complex library of legal materials into an intuitive, accessible, and fast user experience, both on web and mobile. The challenge was to build an interface that could handle thousands of documents in various formats (text, PDF, audio) and offer powerful search, filtering, and personalization features, including highlighting, bookmarks, and offline access through a dedicated mobile app.",
      },
      {
        id: "bdod3",
        text: "Working on this project meant focusing not only on performance and scalability, but also on clarity and usability, essential qualities for a platform used daily by people preparing for public exams or practicing law. It remains one of the projects I’m most proud of.",
      },
    ],
    website: "https://www.buscadordizerodireito.com.br/",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bdod1.png",
        src: BDOD1,
        alt: "Buscar o Direito home page",
      },
      {
        id: "bdod2.png",
        src: BDOD2,
        alt: "Buscar o Direito dowload page",
      },
      {
        id: "bdod3.png",
        src: BDOD3,
        alt: "Buscar o Direito website accessed by mobile device",
      },
    ],
  },
  {
    id: "jenkinslogai",
    name: "JenkinsLogAI",
    date: "Jun 2025 - Aug 2025",
    type: "Web",
    professional: true,
    skills: ["React.js", "AI", "TypeScript", "Axios", "Figma", "Jenkins"],
    about: [
      {
        id: "jenkinslogai1",
        text: "Using components from the React Lib — a library we developed as part of the bank’s Design System (Cordel) — we created a website to help developers troubleshoot Jenkins build issues. To achieve this, we incorporated artificial intelligence using OpenAI’s GPT-4o and GPT-4o Mini models.",
      },
      {
        id: "jenkinslogai2",
        text: "Our team works both on the development of projects — such as POCs, websites, and libraries — and in the support area. We noticed that one of the most frequent service requests involved build failures during the deployment process. Aiming to streamline resolution time and reduce the recurrence of these incidents, we developed this tool. With it, the user pastes the error log into a text field and, upon requesting analysis, instantly receives an explanation of the issue along with clear guidance on how to resolve it.",
      },
      {
        id: "jenkinslogai3",
        text: "Due to the Cordel React Lib, building the JenkinsLogAI interface was fast and efficient. Now, with the site available to the bank's IT staff, we’ve already noticed increased productivity and a significant reduction in repeated support for this kind of issue.",
      },
      {
        id: "jenkinslogai4",
        text: "• Note: At the moment, access to the site is restricted to the bank’s IT professionals.",
      },
    ],
    website: "",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "jenkinslogai1.png",
        src: JENKINSLOGAI1,
        alt: "JenkinsLogAI homepage",
      },
      {
        id: "jenkinslogai2.png",
        src: JENKINSLOGAI2,
        alt: "JenkinsLogAI log analysis page",
      },
      {
        id: "jenkinslogai3.png",
        src: JENKINSLOGAI3,
        alt: "JenkinsLogAI site accessed on a mobile device",
      },
    ],
  },
  {
    id: "jarvis",
    name: "Jarvis",
    date: "Jul 2025 - Oct 2025",
    type: "Web",
    professional: true,
    skills: [
      "Next.js",
      "TypeScript",
      "Responsive Web Design",
      "TanStack Query",
      "React Hook Form",
      "Zod",
      "Jest",
      "React Testing Library",
      "REST API",
    ],
    about: [
      {
        id: "jarvis1",
        text: "Once again, using components from the Cordel React Lib — a library we built as part of the Banco do Nordeste (BNB) Design System — I developed Jarvis, an internal website for digital asset management. The idea was to make employees’ daily work easier by allowing them to check information about certificates, software, and other types of assets, such as description, version, provider, owners, and expiration date.",
      },
      {
        id: "jarvis2",
        text: "In addition to consultations, Jarvis offers full CRUD functionality, allowing users to create, edit, and delete assets directly through the interface — in a simple and integrated way. The application was built with TanStack Query, React Hook Form and Zod validations, with a Java API managing the data in the background. The entire layout was based on Figma prototypes, following the visual and usability standards of the bank’s Design System — which helped keep the result consistent and pleasant to use.",
      },
      {
        id: "jarvis3",
        text: "The key feature is that the system automatically sends emails to the owners of each asset when something is about to expire (or has already expired). This way, no one needs to worry about remembering renewal dates — Jarvis takes care of it for you.",
      },
      {
        id: "jarvis4",
        text: "• Note: As the site is a collaborative tool among employees, access is internal and available only to users who log in using their employee ID.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "jarvis1.png",
        src: JARVIS1,
        alt: "BNB standard SSO login page",
      },
      {
        id: "jarvis2.png",
        src: JARVIS2,
        alt: "Jarvis homepage",
      },
      {
        id: "jarvis3.png",
        src: JARVIS3,
        alt: "Jarvis asset creation form page",
      },
    ],
  },
];

export const ptProjectDetailsData = [
  {
    id: "corelearn",
    name: "CoreLearn",
    date: "Jul 2025 - Jan 2026",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "TypeScript",
      "Contentful",
      "Headless CMS",
      "Next.js App Router",
      "Rotas Dinâmicas",
      "Rich Text Rendering",
      "next/image",
      "Jest",
      "GitHub Actions",
      "Vercel",
    ],
    about: [
      {
        id: "corelearn1",
        text: "Tive a oportunidade de trabalhar em um projeto interno de um site de treinamentos para o nosso time, em que utilizamos integração com Headless CMS, modelagem de conteúdo com Contentful, rotas dinâmicas com Next.js App Router, normalização de dados do CMS com funções mapper, gerenciamento de variáveis de ambiente, renderização de Rich Text do Contentful, renderização de imagens remotas com next/image, renderização de vídeos incorporados, estratégia de revalidação de conteúdo, testes unitários com Jest, CI com GitHub Actions e deploy com Vercel.",
      },
      {
        id: "corelearn2",
        text: "Como o projeto original é interno e não pode ser divulgado publicamente, criei o CoreLearn como um projeto pessoal usando as mesmas tecnologias e práticas. O objetivo foi demonstrar meu conhecimento prático na construção de uma plataforma de aprendizagem orientada por CMS, com conteúdo estruturado, páginas dinâmicas de aulas, componentes reutilizáveis e configuração pensada para produção.",
      },
      {
        id: "corelearn3",
        text: "Com o CoreLearn, pude praticar o fluxo completo de um front-end moderno com headless CMS: modelagem de conteúdo no Contentful, consumo e normalização dos dados do CMS, renderização de conteúdo rico e vídeos incorporados, uso seguro de imagens remotas, validação de variáveis de ambiente, testes unitários, configuração de CI, estratégia de revalidação e publicação da aplicação na Vercel.",
      },
    ],
    website: "https://corelearn.vercel.app/",
    github: "https://github.com/thiagocabralcorreia/corelearn",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "corelearn1.png",
        src: CoreLearn1,
        alt: "Página de listagem de cursos do CoreLearn",
      },
      {
        id: "corelearn2.png",
        src: CoreLearn2,
        alt: "Página de detalhes de aula do CoreLearn",
      },
      {
        id: "corelearn3.png",
        src: CoreLearn3,
        alt: "Layout responsivo de página do CoreLearn",
      },
    ],
  },
  {
    id: "cc",
    name: "Cabral Correia Author Website",
    date: "Jun 2026",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "Responsive Web Design",
      "React Hook Form",
      "Zod",
      "Jest",
      "React Testing Library",
      "Acessibilidade",
      "SEO",
    ],
    about: [
      {
        id: "cc1",
        text: "Cabral Correia Author Website é um projeto pessoal criado após a publicação do meu primeiro livro, Carne e Osso. Além de escrever código profissionalmente, também escrevo contos, e este site foi desenvolvido para apresentar minha trajetória literária, contos selecionados, informações sobre o livro, opções de contato e links sociais em uma experiência visual consistente de marca autoral.",
      },
      {
        id: "cc2",
        text: "Do ponto de vista técnico, construí este projeto como uma demonstração prática da minha experiência com arquitetura front-end moderna. Ele utiliza Next.js App Router, TypeScript, Tailwind CSS, componentes reutilizáveis, rotas dinâmicas para páginas individuais de contos, metadata personalizada para SEO, imagens otimizadas e layout responsivo com foco em leitura e consistência visual.",
      },
      {
        id: "cc3",
        text: "O projeto também inclui validação de formulário com React Hook Form e Zod, testes unitários e de componentes com Jest e React Testing Library, melhorias de acessibilidade como HTML semântico, navegação por teclado, skip link, atributos aria, estilos de focus-visible e página 404 personalizada. É um site real orientado à produção, não apenas um projeto de estudo.",
      },
    ],
    website: "https://www.cabralcorreia.com.br",
    github: "https://github.com/thiagocabralcorreia/cabral-correia",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "cc1.png",
        src: CC1,
        alt: "Seção hero do site Cabral Correia Author Website",
      },
      {
        id: "cc2.png",
        src: CC2,
        alt: "Seção de contos do site Cabral Correia Author Website",
      },
      {
        id: "cc3.png",
        src: CC3,
        alt: "Página do livro no site Cabral Correia Author Website",
      },
    ],
  },
  {
    id: "bnb",
    name: "Cordel Design System React Library",
    date: "Mai 2023 - Presente",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "SCSS",
      "Responsive Web Design",
      "Storybook",
      "Jest",
      "React Testing",
      "Vite",
    ],
    about: [
      {
        id: "bnb1",
        text: "Via Stefanini, fui contratado para trabalhar no Banco do Nordeste (BNB), o maior banco de desenvolvimento social da América Latina. Junto ao time de UX, faço parte da construção do Design System Cordel, com a missão de preencher a lacuna entre designers e desenvolvedores.",
      },
      {
        id: "bnb2",
        text: "Minha tarefa mais impactante tem sido a criação da biblioteca Cordel (uma biblioteca de componentes de interface do usuário). Esse trabalho envolve transformar o design e as variáveis em código, produzindo um complexo conjunto de mais de 50 componentes que são reutilizados em diversos sites da empresa, garantindo alta produtividade no desenvolvimento de futuras telas.",
      },
      {
        id: "bnb3",
        text: "Para a biblioteca voltada para web, utilizei React.js com Vite, TypeScript, SCSS e Storybook (para mostrar, documentar e testar cada componente em isolamento). Através de uma API desenvolvida por nós, as variáveis e tokens do Figma são convertidos de JSON para arquivos SCSS, atualizando em tempo real temas, medidas e demais estilos. Além disso, realizei testes automatizados em cada componente utilizando Jest e React Testing Library.",
      },
      {
        id: "bnb4",
        text: "• Nota: No momento, a biblioteca está acessível apenas para funcionários de TI do banco.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnb1.png",
        src: BNB1,
        alt: "Componente do Cordel Design System apresentado no Storybook",
      },
      {
        id: "bnb2.png",
        src: BNB2,
        alt: "Componente do Cordel Design System apresentado no Storybook",
      },
      {
        id: "bnb3.png",
        src: BNB3,
        alt: "Componente do Cordel Design System apresentado no Storybook",
      },
    ],
  },
  {
    id: "bnbrn",
    name: "Cordel Design System React Native Library",
    date: "Mar 2025 - Presente",
    type: "Web",
    professional: true,
    skills: [
      "React Native",
      "TypeScript",
      "Storybook",
      "Jest",
      "React Native Testing",
      "React Compound Pattern",
    ],
    about: [
      {
        id: "bnbrn1",
        text: "Assim como fui responsável pela biblioteca React do Cordel Design System, também ajudei a construir a versão React Native, focada em aplicativos mobile. Dessa vez, com tudo que aprendi antes, o processo foi bem mais certeiro — e o resultado ficou leve, padronizado e muito prático de usar.",
      },
      {
        id: "bnbrn2",
        text: "É bem legal ver os desenvolvedores montando apps com essa biblioteca: parece montar Lego — os componentes já estão prontos e bonitos, e eles só precisam se preocupar com a lógica. Usamos React Native, TypeScript e Storybook pra documentar e testar tudo direitinho, além de uma API que converte os tokens do Figma em objetos JavaScript, atualizando temas e estilos em tempo real.",
      },
      {
        id: "bnbrn3",
        text: "• Nota: Por enquanto, a biblioteca é usada apenas em projetos internos do banco, então o código e os apps não são públicos.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbrn1.png",
        src: BNBRN1,
        alt: "Componente da Cordel Design System React Native Library apresentado no Storybook",
      },
      {
        id: "bnbrn2.png",
        src: BNBRN2,
        alt: "Componente da Cordel Design System React Native Library apresentado no Storybook",
      },
      {
        id: "bnbrn3.png",
        src: BNBRN3,
        alt: "Componente da Cordel Design System React Native Library apresentado no Storybook",
      },
    ],
  },
  {
    id: "digital-platform",
    name: "Plataforma Digital BNB",
    date: "Mai 2023 - Ago 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Docusaurus",
      "Markdown",
      "Responsive Web Design",
      "Gitlab",
    ],
    about: [
      {
        id: "bnbdp1",
        text: "Embora minha principal tarefa tenha sido a construção da biblioteca de componentes React do Design System do Banco do Nordeste (BNB), meu primeiro projeto foi a Plataforma Digital, um site de documentação colaborativa criado com Docusaurus, gerador de sites estático que possibilita a combinação de Markdown com componentes React.",
      },
      {
        id: "bnbdp2",
        text: "Este portal é utilizado por todos os colaboradores da TI do Banco do Nordeste a fim de informar e ser informado a respeito de diretrizes e guias para desempenhar as atividades de desenvolvimento e testes. Esta implementação resultou em um acréscimo de mais de 50% de engajamento em comparação à versão anterior da Plataforma Digital.",
      },
      {
        id: "bnbdp3",
        text: "• Nota: O portal é acessado apenas por funcionários da TI do banco e seu site não pode ser divulgado.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbpd1.png",
        src: DigitalPlatform1,
        alt: "Portal Plataforma Digital",
      },
      {
        id: "bnbpd2.png",
        src: DigitalPlatform2,
        alt: "Portal Plataforma Digital",
      },
      {
        id: "bnbpd3.png",
        src: DigitalPlatform3,
        alt: "Portal Plataforma Digital",
      },
    ],
  },
  {
    id: "scoutfy",
    name: "Scoutfy",
    date: "Jul 2021 - Abr 2022",
    type: "Web",
    professional: true,
    skills: [
      "Next.js",
      "Responsive Web Design",
      "Styled-Components",
      "Storybook",
      "Redux Toolkit",
      "CI/CD",
      "Vercel",
    ],
    about: [
      {
        id: "scoutfy1",
        text: "Este foi o primeiro projeto profissional que desenvolvi com React e Next.js, um website grandioso, importante aprendizado, complexo, responsivo, repleto de componentes reutilizáveis.",
      },
      {
        id: "scoutfy2",
        text: "Scoutfy é uma plataforma de gestão esportiva intuitiva para esportistas amadores e atletas de alto rendimento, que podem elaborar um currículo esportivo, solicitar bolsas e patrocínios, entrar em contato com a comunidade, gerenciar afiliações, membros, eventos, competições, equipes, membros da comissão, assinaturas e suporte.",
      },
    ],
    website: "https://scoutfy.webflow.io",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "scoutfy1.png",
        src: Scoutfy1,
        alt: "Scoutfy logo",
      },
      {
        id: "scoutfy2.png",
        src: Scoutfy2,
        alt: "Tela de login do site Scoutfy",
      },
    ],
  },
  {
    id: "bnbui",
    name: "BNB-UI",
    date: "May 2023 - Aug 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Material-UI",
      "Responsive Web Design",
      "Storybook",
    ],
    about: [
      {
        id: "bnbui1",
        text: "Antes de iniciar a biblioteca React para o Design System do Banco do Nordeste, contribuí para o desenvolvimento de funcionalidades e manutenção de uma biblioteca de componentes React já existente, a BNB-UI. Ao contrário da nova biblioteca, onde todos os componentes foram criados do zero e estilizados com SCSS, a BNB-UI foi construída com Material-UI, seguindo as boas práticas definidas pelo Google através do Material Design.",
      },
      {
        id: "bnbui2",
        text: "Além da manutenção e criação de novos componentes personalizados, conforme solicitado pelo cliente, também atualizei toda a documentação no Storybook. Contudo, ao desenvolver o Design System, construí uma biblioteca React mais autêntica e completa, que segue o padrão visual e a consistência que serão mantidos em outras bibliotecas de diferentes linguagens. Vale ressaltar que adicionei melhorias, como o uso do Jest para testes unitários, garantindo maior robustez e confiabilidade dos componentes.",
      },
      {
        id: "bnbui3",
        text: "• Nota: No momento, a biblioteca está acessível apenas para funcionários.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbui1.png",
        src: BNBUI1,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
      {
        id: "bnbui2.png",
        src: BNBUI2,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
      {
        id: "bnbui3.png",
        src: BNBUI3,
        alt: "Cordel Design System React Library component shown in Storybook",
      },
    ],
  },
  {
    id: "bnbui",
    name: "BNB-UI",
    date: "May 2023 - Aug 2023",
    type: "Web",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Material-UI",
      "Responsive Web Design",
      "Storybook",
    ],
    about: [
      {
        id: "bnbui1",
        text: "Antes de iniciar a biblioteca React para o Design System do Banco do Nordeste, contribuí para o desenvolvimento de funcionalidades e manutenção de uma biblioteca de componentes React já existente, a BNB-UI. Ao contrário da nova biblioteca, onde todos os componentes foram criados do zero e estilizados com SCSS, a BNB-UI foi construída com Material-UI, seguindo as boas práticas definidas pelo Google através do Material Design.",
      },
      {
        id: "bnbui2",
        text: "Além da manutenção e criação de novos componentes personalizados, conforme solicitado pelo cliente, também atualizei toda a documentação no Storybook. Contudo, ao desenvolver o Design System, construí uma biblioteca React mais autêntica e completa, que segue o padrão visual e a consistência que serão mantidos em outras bibliotecas de diferentes linguagens. Vale ressaltar que adicionei melhorias, como o uso do Jest para testes unitários, garantindo maior robustez e confiabilidade dos componentes.",
      },
      {
        id: "bnbui3",
        text: "• Nota: No momento, a biblioteca está acessível apenas para funcionários.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bnbui1.png",
        src: "BNBUI1",
        alt: "Página de introdução BNB-UI apresentada no Storybook",
      },
      {
        id: "bnbui2.png",
        src: "BNBUI2",
        alt: "Componente BNB-UI apresentado no Storybook",
      },
      {
        id: "bnbui3.png",
        src: "BNBUI3",
        alt: "Componente BNB-UI apresentado no Storybook",
      },
    ],
  },
  {
    id: "caule",
    name: "Caule",
    date: "Ago 2022 - Fev 2023",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "TypeScript",
      "REST API",
      "Styled-Components",
      "GitLab",
    ],
    about: [
      {
        id: "caule1",
        text: "Um dos projetos mais ambiciosos de que já participei. Ao ingressar na equipe Nano Incub, meu primeiro desafio foi trabalhar no desenvolvimento móvel desta plataforma de negócios super completa, Caule, utilizada por mais de 30.000 funcionários das maiores usinas do país.",
      },
      {
        id: "caule2",
        text: "Caule é um aplicativo móvel feito sob medida para grandes corporações que possuem milhares de funcionários distribuídos geograficamente (no escritório, no campo, remotamente), facilitando a vida tanto do empregador quanto do empregado.",
      },
      {
        id: "caule3",
        text: "Através do aplicativo, os colaboradores podem acessar folha de pagamento e de férias, receber apostilas, distribuir conteúdo institucional e diversas outras funcionalidades personalizadas - tudo integrado às principais Enterprise Resource Planning's do mercado (SAP, Totvs e Senior). Sua implantação apresenta um alto desempenho contra a lentidão dos processos burocráticos.",
      },
    ],
    website: "https://caule.app",
    github: "",
    appleStore: "https://apps.apple.com/br/app/caule/id6444843213",
    playStore: "https://play.google.com/store/apps/details?id=com.caule.app",
    images: [
      {
        id: "caule1.png",
        src: Caule1,
        alt: "Smartphones com telas do aplicativo Caule",
      },
      {
        id: "caule2.png",
        src: Caule2,
        alt: "Smartphones com telas do aplicativo Caule",
      },
    ],
  },
  {
    id: "coffee-house",
    name: "CoffeeHouse",
    date: "Set 2021 - Nov 2021",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "Context API",
      "JavaScript",
      "HTML",
      "SASS",
      "Photoshop",
      "Illustrator",
    ],
    about: [
      {
        id: "ch1",
        text: "Esse foi meu primeiro projeto pessoal, construído do zero com minhas ideias e meu design. Como um amante de café, fiquei super empolgado em criar uma rede fictícia de cafeterias londrinas: marca, identidade visual, cardápio e endereços. Elaborei até as artes gráficas com letreiros, fachadas e banners deste site, editadas com Adobe Photoshop.",
      },
      {
        id: "ch2",
        text: "Foi uma forma desafiadora e muito divertida de colocar em prática meus conhecimentos de React.js. Entre as funcionalidades: design responsivo usando Sass, slider de imagens infinito, menu mobile, grid da galeria com modal slideshow, página de endereços usando filtro de lojas, quiz de café com pontuação, formulário de contato e assinatura de newsletter com validação, página de menu com contexto, animações CSS e gráficos.",
      },
    ],
    website: "https://coffeehouse-website-kohl.vercel.app",
    github: "https://github.com/thiagocabralcorreia/coffeehouse-website",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "coffeehouse1.png",
        src: CoffeeHouse1,
        alt: "Website CoffeeHouse",
      },
      {
        id: "coffeehouse2.png",
        src: CoffeeHouse2,
        alt: "Website CoffeeHouse",
      },

      {
        id: "coffeehouse3.png",
        src: CoffeeHouse3,
        alt: "Website CoffeeHouse",
      },
    ],
  },
  {
    id: "wee-travel",
    name: "Wee Travel",
    date: "Abr 2021 - Ago 2021",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "Styled-Components",
      "JavaScrip",
      "Redux",
      "GitHub",
    ],
    about: [
      {
        id: "wee1",
        text: "Desenvolvido assim que ingressei na NB Consulting. Um aplicativo móvel de gestão de viagens corporativas com informações atualizadas sobre companhias aéreas, OBT (Online booking travel) e Enterprise Resource Planning, acessado por diferentes perfis, como gestor de viagens, centro de custo gestor e viajante.",
      },
    ],
    website: "https://weetravel.com.br/",
    github: "",
    appleStore: "",
    playStore:
      "https://play.google.com/store/apps/details?id=br.com.tursites.weereceptivocombr&hl=pt_PT",
    images: [
      {
        id: "weetravel1.png",
        src: WeeTravel1,
        alt: "Smartphones com telas do aplicativo WeeTravel",
      },
      {
        id: "weetravel2.png",
        src: WeeTravel2,
        alt: "Smartphones com telas do aplicativo WeeTravel",
      },
    ],
  },
  {
    id: "film-n-chips",
    name: "Film N Chips",
    date: "Jul 2022",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "REST API",
      "Redux Toolkit",
      "Styled-Components",
      "Vercel Deploy",
    ],
    about: [
      {
        id: "film1",
        text: "Após a conclsão de um curso da Udemy, React Redux, resolvi colocar em prática o que aprendi. Fascinado por cinema, criei meu próprio site de filmes, com dados da API do IMDb.",
      },
      {
        id: "film2",
        text: "Este é um site de banco de dados de filmes. Dados on-line relacionados a filmes, como especificações do filme, sinopse, elenco, pôsteres, classificações indicativas e muito mais. Deploy via Vercel. Essa API permite apenas 1.000 solicitações por dia.",
      },
    ],
    website: "https://film-and-chips-website.vercel.app",
    github: "https://github.com/thiagocabralcorreia/film-and-chips-website",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "film-n-chips1.png",
        src: FilmNChips1,
        alt: "Página do site Film N Chips",
      },
      {
        id: "film-n-chips2.png",
        src: FilmNChips2,
        alt: "Página do site Film N Chips",
      },

      {
        id: "film-n-chips3.png",
        src: FilmNChips3,
        alt: "Página do site Film N Chips",
      },
    ],
  },
  {
    id: "appqd",
    name: "APPqd",
    date: "Abr 2021 - Ago 2021",
    type: "Mobile",
    professional: true,
    skills: [
      "React Native",
      "Styled-Components",
      "JavaScrip",
      "Redux",
      "GitHub",
    ],
    about: [
      {
        id: "appqd1",
        text: "Minha segunda experiência profissional com aplicativo móvel, na NB Consulting IT. Este é um aplicativo muito original, um diário de bordo que ajuda os paraquedistas. Entre as diversas funcionalidades, estão simuladores, calculadora de carga alar, previsão de vento e clima, caderno de dados e equipamentos de salto.",
      },
      {
        id: "appqd2",
        text: "A interface do usuário é muito simples e bonita, e lembro de ter ouvido muitos elogios de clientes satisfeitos.",
      },
    ],
    website: "",
    github: "",
    appleStore:
      "https://apps.apple.com/hr/app/appqd-skydive-e-base-jump/id1548125179?l=hr",
    playStore: "https://play.google.com/store/apps/details?id=com.appqd",
    images: [
      {
        id: "appqd1.png",
        src: APPqd1,
        alt: "Smartphones com telas do aplicativo APPqd",
      },
      {
        id: "appqd2.png",
        src: APPqd2,
        alt: "Smartphones com telas do aplicativo APPqd",
      },
    ],
  },
  {
    id: "web-accessibility",
    name: "Web Accessibility",
    date: "Jul 2022",
    type: "Web",
    professional: false,
    skills: [
      "Next.js",
      "Responsive Web Design",
      "TypeScript",
      "Tailwind CSS",
      "Apiary",
      "AAA",
      "UX/UI",
      "Vercel",
    ],
    about: [
      {
        id: "wa1",
        text: "Este site responsivo foi planejado e desenvolvido visando o conhecimento teórico e o estudo prático sobre acessibilidade web, seguindo boas práticas, como uso de contraste, tema alternativo, interface compreensível e fácil navegação, com interação por teclado.",
      },
      {
        id: "wa2",
        text: "Dentre as tecnologias aplicadas, utilizei o Next.js 13 e os novos recursos experimentais, incluindo a nova forma de buscar dados e tratar as promessas dentro dos componentes. Interface de usuário simples e de fácil leitura com foco na experiência do usuário. Utilizei o Apiary como a pilha de design da API para simular a busca de dados.",
      },
    ],
    website: "https://web-accessibility-nine.vercel.app",
    github: "https://github.com/thiagocabralcorreia/web-accessibility",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "wa1.png",
        src: WA1,
        alt: "Página do site Web Accessibility",
      },
      {
        id: "wa2.png",
        src: WA2,
        alt: "Página do site Web Accessibility",
      },

      {
        id: "wa3.png",
        src: WA3,
        alt: "Página do site Web Accessibility",
      },
    ],
  },
  {
    id: "gofinances",
    name: "GoFinances",
    date: "Set 2022 - Out 2022",
    type: "Mobile",
    professional: false,
    skills: [
      "React Native",
      "TypeScript",
      "Expo",
      "Styled-Components",
      "Social Login",
      "UX/UI",
    ],
    about: [
      {
        id: "finance1",
        text: "Mais uma missão de estudo. Por meio do curso Rocketseat Ignite, desenvolvi um aplicativo móvel para gerenciamento das finanças pessoais do usuário, incluindo cartões de entradas/saídas, gráfico de resumo mensal e autenticação de login social.",
      },
      {
        id: "finance2",
        text: "Revisei e pratiquei TypeScript e Styled-Components, aprendi sobre autenticação com contas Google e Apple, armazenamento com AsyncStorage, uso de gráfico com filtros de data e validação Yup.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/gofinances-app",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "gofinances1.png",
        src: GoFinances1,
        alt: "Smartphones com telas do aplicativo GoFinances",
      },
      {
        id: "gofinances2.png",
        src: GoFinances2,
        alt: "Smartphones com telas do aplicativo GoFinances",
      },
    ],
  },
  {
    id: "portfolio",
    name: "Portfolio",
    date: "Feb 2023",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "Taildwind CSS",
      "UX/UI",
      "EmailJS",
      "Vercel Deploy",
    ],
    about: [
      {
        id: "portfolio1",
        text: "Tenho orgulho do trabalho que dediquei a este projeto e espero que sirva como uma boa representação de minhas habilidades e experiência.",
      },
      {
        id: "portfolio2",
        text: "Construído com React.js, TypeScript e Tailwind CSS, este site é totalmente responsivo e inclui currículo para download, links para perfis de mídia social, seção de introdução, lista de habilidades, grade de projeto, páginas de projeto detalhados, slider de recomendação e formulário de contato desenvolvido por EmailJS.",
      },
      {
        id: "portfolio3",
        text: "Para aprimorar a experiência do usuário, incorporei o Framer Motion para animações suaves e o React Scroll para rolagem contínua entre as seções. Mais recentemente, adicionei mudança de tema e seleção de idioma (Português e Inglês).",
      },
    ],
    website: "https://thiagocabralcorreia.vercel.app",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "portfolio1.png",
        src: Portfolio1,
        alt: "Home page do site Portfolio",
      },
      {
        id: "portfolio2.png",
        src: Portfolio2,
        alt: "Grid de projetos do site Portfolio",
      },
      {
        id: "portfolio3.png",
        src: Portfolio3,
        alt: "Seções de contato e recomendações do site Portfolio",
      },
    ],
  },
  {
    id: "dev-meetup",
    name: "DevMeetup",
    date: "Apr 2023",
    type: "Web",
    professional: false,
    skills: [
      "React.js",
      "Responsive Web Design",
      "TypeScript",
      "Taildwind CSS",
      "UX/UI",
      "Node.js",
      "Express",
      "MongoDB",
      "Web Sockets",
      "JSON Web Token",
    ],
    about: [
      {
        id: "devmeetup1",
        text: "Inspirado ao assistir e estudar um MERN Bootcamp, desenvolvi esse projeto do Back-end ao Front-end. Trata-se de um website para consultar, criar, editar e se cadastrar em meetups de desenvolvedores.",
      },
      {
        id: "devmeetup2",
        text: "No front-end, desenvolvi um design responsivo com formulários de login e cadastro, um painel exibindo todos os eventos de meetup (com informações e imagem), um filtro de categoria e muito mais. Também criei uma simples marca com ícone e fonte especial, para dar mais autenticidade.",
      },
      {
        id: "devmeetup3",
        text: "No back-end, integrei o registro e autenticação de usuários, controle de sessão, operações CRUD e pesquisa de eventos usando filtros. Também incluí a inscrição em eventos e upload de imagens para o servidor. Foi uma excelente experiência trabalhar com JSON Web Token e Web Sockets.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/dev-meetup",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "devmeetup1.png",
        src: DevMeetup1,
        alt: "Site DevMeetup com painel",
      },
      {
        id: "devmeetup2.png",
        src: DevMeetup2,
        alt: "Design responsivo de DevMeetup em tela de celular",
      },
      {
        id: "devmeetup3.png",
        src: DevMeetup3,
        alt: "Formulário de criar evento do site DevMeetup",
      },
    ],
  },
  {
    id: "cnh",
    name: "Comida na Hora",
    date: "Dez 2022 - Jan 2023",
    type: "Mobile",
    professional: false,
    skills: [
      "React Native",
      "REST API",
      "TypeScript",
      "Styled-Components",
      "UX/UI",
    ],
    about: [
      {
        id: "cnh1",
        text: "Lançada em 2017 pela empreendedora Débora Dotto, a startup Comida na Hora é um marketplace especializado em pedidos e entregas de comida, atuando no interior de Goiás, Brasil, com sede em Mineiros/GO. A empresa já alcançou números notáveis: mais de 16 mil clientes, mais de 400 estabelecimentos parceiros, mais de 140k pedidos entregues e um faturamento que ultrapassa R$ 6 milhões.",
      },
      {
        id: "cnh2",
        text: "Na Nano Incub, uma de nossas missões foi desenvolver uma nova versão do aplicativo móvel, que já existia e estava em funcionamento (sua primeira versão criada com Iconic e Laravel). Refizemos com React Native e adicionamos novos elementos a fim de melhorar a experiência do usuário.",
      },
    ],
    website: "https://comidanahora.com.br/",
    github: "",
    appleStore: "https://apps.apple.com/br/app/comida-na-hora/id1517670680",
    playStore:
      "https://play.google.com/store/apps/details?id=com.nanoincub.comidanahora&hl=pt&gl=US",
    images: [
      {
        id: "cnh1.png",
        src: CNH1,
        alt: "Smartphones with Comida na Hora app screens",
      },
      {
        id: "cnh2.png",
        src: CNH2,
        alt: "Smartphones with Comida na Hora app screens",
      },
    ],
  },
  {
    id: "british-beers",
    name: "British Beers",
    date: "Jun 2024",
    type: "Web",
    professional: false,
    skills: ["Next.js", "TypeScript", "Taildwind CSS", "SSR"],
    about: [
      {
        id: "britishbeers1",
        text: "Este website foi desenvolvido para fins de estudo, a fim de aprender novas features do Next.js App Router através da prática. Como bom apreciador de cervejas do Reino Unido, construí um e-commerce simples de cervejas britânicas, com foco na busca de dados.",
      },
      {
        id: "britishbeers2",
        text: "• Nota: Uma vez que este projeto teve fins apenas para estudo de App Router, criei simples API com o próprio Next.js, não foquei na responsividade do site nem adicionei a página de carrinho nem ferramenta de compra.",
      },
    ],
    website: "",
    github: "https://github.com/thiagocabralcorreia/british-beers",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "british-beers1.png",
        src: BritishBeers1,
        alt: "Página inicial do site British Beers",
      },
      {
        id: "british-beers2.png",
        src: BritishBeers2,
        alt: "Página de produto do site British Beers",
      },
      {
        id: "british-beers3.png",
        src: BritishBeers3,
        alt: "Página de detalhes de produto do site British Beers",
      },
    ],
  },
  {
    id: "cvfy",
    name: "CVFY",
    date: "Abr 2022 - Ago 2022",
    type: "Mobile",
    professional: true,
    skills: [
      "React.js",
      "TypeScript",
      "Styled-Components",
      "React Native",
      "MobX",
    ],
    about: [
      {
        id: "cvfy1",
        text: "Realizei um projeto freelance remoto em colaboração com uma equipe localizada em Northampton, Inglaterra. Este projeto compreendia duas frentes principais: o desenvolvimento de um aplicativo móvel de busca de emprego e a criação de uma landing page.",
      },
      {
        id: "cvfy2",
        text: "O aplicativo foi concebido com um foco acentuado na experiência do usuário e em um design limpo e intuitivo. Utilizei React Native e TypeScript. O objetivo foi proporcionar uma navegação simplificada e eficiente, com funcionalidades de busca e aplicação de empregos impulsionadas por inteligência artificial.",
      },
      {
        id: "cvfy3",
        text: "Para complementar o aplicativo, desenvolvi uma landing page responsiva e mobile-first com React e TypeScript. A página foi projetada para maximizar a conversão de visitantes em usuários da plataforma, com um layout atraente e fácil de navegar. O design foi implementado utilizando Styled-components e mockups criados no Adobe XD.",
      },
    ],
    website: "",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "cvfy.png",
        src: CVFY,
        alt: "Marca da plataforma CVFY",
      },
    ],
  },
  {
    id: "bdod",
    name: "Buscador Dizer o Direito",
    date: "Ago 2022 - Fev 2023",
    type: "Web",
    professional: true,
    skills: ["React.js", "TypeScript", "Styled-Components", "Figma"],
    about: [
      {
        id: "bdod1",
        text: "Um dos projetos mais significativos em que atuei foi o desenvolvimento front-end do Buscador Dizer o Direito, uma plataforma de pesquisa jurídica que se tornou uma ferramenta essencial para milhares de estudantes e profissionais do Direito no Brasil. Criada pelo Professor Márcio Cavalcante, a plataforma evoluiu de um blog pessoal para um produto digital completo, com conteúdo jurídico selecionado dos principais tribunais do país.",
      },
      {
        id: "bdod2",
        text: "Meu papel foi ajudar a transformar essa extensa e complexa biblioteca de materiais jurídicos em uma experiência de uso intuitiva, acessível e ágil, tanto no web quanto no mobile. O desafio era criar uma interface capaz de lidar com milhares de documentos em diversos formatos (texto, PDF, áudio) e oferecer recursos poderosos de busca, filtragem e personalização, como marcações, favoritos e acesso offline por meio de um app dedicado.",
      },
      {
        id: "bdod3",
        text: "Trabalhar nesse projeto exigiu foco não apenas em performance e escalabilidade, mas também em clareza e usabilidade, qualidades essenciais para uma plataforma utilizada diariamente por quem estuda para concursos ou atua na área jurídica. É, até hoje, um dos trabalhos dos quais mais me orgulho.",
      },
    ],
    website: "https://www.buscadordizerodireito.com.br/",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "bdod1.png",
        src: BDOD1,
        alt: "Página inicial do Buscador Dizer o Direito",
      },
      {
        id: "bdod2.png",
        src: BDOD2,
        alt: "Página de download do Buscador Dizer o Direito",
      },
      {
        id: "bdod3.png",
        src: BDOD3,
        alt: "Site do Buscador Dizer o Direito acessado por um dispositivo móvel",
      },
    ],
  },
  {
    id: "jenkinslogai",
    name: "JenkinsLogAI",
    date: "Jun 2025 - Ago 2025",
    type: "Web",
    professional: true,
    skills: ["React.js", "AI", "TypeScript", "Axios", "Figma", "Jenkins"],
    about: [
      {
        id: "jenkinslogai1",
        text: "Utilizando os componentes da Cordel React Lib — biblioteca que desenvolvemos como parte do Design System do banco —, criamos um site para auxiliar desenvolvedores a resolverem problemas de build no Jenkins. Para isso, incorporamos inteligência artificial, utilizando os modelos GPT-4o e GPT-4o Mini, da OpenAi.",
      },
      {
        id: "jenkinslogai2",
        text: "Nosso time atua tanto no desenvolvimento de projetos — como POCs, sites e bibliotecas — quanto na área de suporte. Observamos que uma das demandas mais recorrentes envolve falhas na build durante o processo de deploy. Pensando em otimizar o tempo e reduzir a recorrência desses chamados, desenvolvemos essa ferramenta. Com ela, o usuário cola o log de erro no campo de texto e, ao solicitar a análise, recebe imediatamente uma explicação sobre o problema encontrado, acompanhada de uma orientação clara para resolvê-lo.",
      },
      {
        id: "jenkinslogai3",
        text: "Graças à Cordel React Lib, a construção da interface do JenkinsLogAI foi rápida e eficiente. Agora, com o site disponível para os colaboradores da área de TI do banco, já percebemos um aumento na produtividade e uma expressiva redução na repetição desse tipo de atendimento.",
      },
      {
        id: "jenkinslogai4",
        text: "• Nota: No momento, o acesso ao site está restrito aos profissionais de TI do banco.",
      },
    ],
    website: "",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "jenkinslogai1.png",
        src: JENKINSLOGAI1,
        alt: "Página inicial do JenkinsLogAI",
      },
      {
        id: "jenkinslogai2.png",
        src: JENKINSLOGAI2,
        alt: "Página de análise de log do JenkinsLogAI",
      },
      {
        id: "jenkinslogai3.png",
        src: JENKINSLOGAI3,
        alt: "Site do JenkinsLogAI acessado por um dispositivo móvel",
      },
    ],
  },
  {
    id: "jarvis",
    name: "Jarvis",
    date: "Jul 2025 - Out 2025",
    type: "Web",
    professional: true,
    skills: [
      "Next.js",
      "TypeScript",
      "Responsive Web Design",
      "TanStack Query",
      "React Hook Form",
      "Zod",
      "Jest",
      "React Testing Library",
      "REST API",
    ],
    about: [
      {
        id: "jarvis1",
        text: "Mais uma vez, usando os componentes da Cordel React Lib — biblioteca que criamos como parte do Design System do Banco do Nordeste (BNB) — desenvolvi o Jarvis, um site interno para gestão de ativos digitais. A ideia foi facilitar o dia a dia dos funcionários, permitindo consultar informações sobre certificados, softwares e outros tipos de ativos, como descrição, versão, fornecedor, responsáveis e data de expiração.",
      },
      {
        id: "jarvis2",
        text: "Além da consulta, o Jarvis oferece funcionalidades completas de CRUD, possibilitando criação, edição e exclusão de ativos diretamente pela interface, tudo de forma simples e integrada. A aplicação foi construída com TanStack Query,React Hook Form e validações Zod, com uma API em Java por trás para gerenciar os dados. Todo o layout foi feito a partir dos protótipos no Figma, seguindo o padrão visual e de usabilidade do Design System do banco — o que ajudou bastante a deixar o resultado consistente e agradável de usar.",
      },
      {
        id: "jarvis3",
        text: "O diferencial é que o sistema envia e-mails automáticos para os responsáveis por cada ativo quando algo estiver perto de vencer (ou já tiver vencido). Assim, ninguém precisa se preocupar em lembrar das renovações — o Jarvis faz isso por você.",
      },
      {
        id: "jarvis4",
        text: "• Nota: Como o site é colaborativo entre os funcionários, o acesso é interno, disponível apenas para quem faz login com a matrícula funcional.",
      },
    ],
    website: "https://www.bnb.gov.br",
    github: "",
    appleStore: "",
    playStore: "",
    images: [
      {
        id: "jarvis1.png",
        src: JARVIS1,
        alt: "Página de login padrão SSO do BNB",
      },
      {
        id: "jarvis2.png",
        src: JARVIS2,
        alt: "Página Home do site Jarvis",
      },
      {
        id: "jarvis3.png",
        src: JARVIS3,
        alt: "Página de formulário de criação de ativos do site Jarvis",
      },
    ],
  },
];
